module.exports = __webpack_public_path__ + "img/jfsc.51a4ff4f.png";